(() => {
    const initRadioListeners = () => {
        const oneTimeRadio = document.querySelector('[data-radio-onetime]');
        const subscribeRadio = document.querySelector('[data-radio-subsave]');
        
        if (oneTimeRadio && subscribeRadio) {
            oneTimeRadio.addEventListener('change', function() {
                if (this.checked) {
                    window.Abra.useSellingPlanPriceOnProductBlock = false;
                    window.Abra.render();
                }
            });
            
            subscribeRadio.addEventListener('change', function() {
                if (this.checked) {
                    window.Abra.useSellingPlanPriceOnProductBlock = true;
                    window.Abra.render();
                }
            });
            
            return true;
        }
        return false;
    };
    
    if (!initRadioListeners()) {
        const observer = new MutationObserver(() => {
            if (initRadioListeners()) {
                observer.disconnect();
            }
        });
        
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }
})();

(() => {
  let reloadTimeout = null;
  let tNow = null, tLater = null;
  let reloadScheduled = false;
  
  const isCartPage = () => {
    const path = window.location.pathname;
    return path === '/cart' || path === '/cart/';
  };
  
  const refreshNow = () => {
    window.goCart && goCart.fetchCart && goCart.fetchCart();
  };
  
  const scheduleReload = (delay = 3000) => {  // 
    if (!isCartPage() || reloadScheduled) return;
    
    reloadScheduled = true;
    if (reloadTimeout) clearTimeout(reloadTimeout);
    
    reloadTimeout = setTimeout(() => {
      window.location.reload();
    }, delay);  // 
  };
  
  const schedule = () => {
    tNow && clearTimeout(tNow);
    tNow = setTimeout(refreshNow, 200);
    tLater && clearTimeout(tLater);
    tLater = setTimeout(refreshNow, 5000);
  };
  
  const ofetch = window.fetch;
  window.fetch = function() {
    const args = arguments;
    const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
    const isCart = /\/cart\/(add|change|update)\.js($|\?)/.test(url);
    return ofetch.apply(this, args).then(r => {
      if (isCart && r.ok) {
        schedule();
      }
      return r;
    });
  };
  
  if (window.jQuery && jQuery.ajax) {
    const oajax = jQuery.ajax;
    jQuery.ajax = function(opts) {
      const url = typeof opts === 'string' ? opts : (opts && opts.url) || '';
      const isCart = /\/cart\/(add|change|update)\.js($|\?)/.test(url);
      const jq = oajax.apply(this, arguments);
      if (isCart && jq && jq.always) {
        jq.always(() => schedule());
      }
      return jq;
    };
  }
  
  document.addEventListener('click', e => {
    const t = e.target;
    
    if (t.matches('button[name="plus"], button[name="minus"]')) {
      scheduleReload(3500);  
    }
    
    if (t.matches('.cartitemm-remove') || t.closest('.cartitemm-remove')) {
      scheduleReload(3000);  
    }
    
    if (t.matches('a[href*="/cart/add"]') || t.closest('a[href*="/cart/add"]')) {
      scheduleReload(3000);  
    }
    
    if (t.closest('.js-go-cart-quantity-plus,.js-go-cart-quantity-minus,.js-go-cart-remove-from-cart,.js-go-cart-add-to-cart')) {
      setTimeout(schedule, 400);
      scheduleReload(2500); 
    }
  }, true);
  
  document.addEventListener('submit', e => {
    if (e.target.matches('form[action*="/cart/add"]')) {
      scheduleReload(3500);  
    }
  });
})();


(() => {
  if (!window.location.pathname.includes('/products')) return;
  
  const apply = () => {
    const hasShadowRecharge = [...document.querySelectorAll('*')].some(el => 
      el.shadowRoot?.querySelector('.rc-widget__root, .rc-purchase-option')
    );
    
    if (hasShadowRecharge && window.Abra) {
      window.Abra.useSellingPlanPriceOnProductBlock = true;
      window.Abra.render();
    }
  };

  apply();
  [300, 1000, 2000].forEach(t => setTimeout(apply, t));

  new MutationObserver(apply).observe(document.body, {childList: true, subtree: true});
  
  document.addEventListener('DOMContentLoaded', apply);
  window.addEventListener('load', apply);
})();
